import lpevents from '../tracking/lpevents';
import { store } from '../globals';
import { lpIdGetPure } from './global_getter';
import lpApp from '../app/lp_app';

/*
* Project: LegalPlace assistant
* File: src/logic/action_counter.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/


/** @type {Object} */
let VariableActions = {};
/** @type {Object} */
let OptionActions = {};


function initializeCounters() {
  VariableActions = {};
  OptionActions = {};
}
/**
 * Fired when we edit an option, so we can log the option as selected
 * @param {string|number} id
 */
function raiseOption(id) {
  if (typeof OptionActions[id] === 'undefined') {
    if ((Object.keys(OptionActions).length + 1) % 4 === 0) {
      const event = {};
      event['Options mod four'] = (Object.keys(OptionActions).length + 1) / 4;
      event['Contract name'] = window.contractName;
      lpevents.track('Edited Options', event);
    }
  }
  OptionActions[id] = true;

  window._os = OptionActions;
}
/**
 * Fired when a variable is edited, so we can log it as EDITED
 * @param {string|number} id
 */
function raiseVariable(id) {
  if (lpApp.mutex.checkMutex('preview')) {
    if (typeof VariableActions[id] === 'undefined') {
      if ((Object.keys(VariableActions).length + 1) % 4 === 0) {
        const event = {};
        event['Variables mod four'] = (Object.keys(VariableActions).length + 1) / 4;
        event['Contract name'] = window.contractName;
        lpevents.track('Edited variables', event);
      }
    }
  }
  VariableActions[id] = true;
  window._vs = VariableActions;
}

/**
 * Get the number of edited variables on the document, including the ones loaded from the OVC.
 */
function getEditedVariables() {
  // updating if there is a variable or an option in there
  const { vF } = store.getState().loadedOvc;
  const vFKeys = (typeof vF === 'undefined') ? [] : Object.keys(vF);
  vFKeys.map((idx) => {
    if (vF[idx] !== '')VariableActions[idx] = true;
  });
  if (typeof VariableActions === 'undefined') return 0;
  return Object.keys(VariableActions).length;
}


/**
 * Get the number of edited options, radios or checkbox, including the options loaded from OVC
 */
function getEditedOptions() {
  const { oF } = store.getState().loadedOvc;
  const { cF } = store.getState().loadedOvc;
  const oFKeys = (typeof oF === 'undefined') ? [] : Object.keys(oF);
  const cFKeys = (typeof cF === 'undefined') ? [] : Object.keys(cF);
  oFKeys.map((idx) => {
    if ((oF[idx]) && lpApp.references.getOption(lpIdGetPure(idx)) && (lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'radio'))OptionActions[idx] = true;
  });
  cFKeys.map((idx) => {
    if ((cF[idx]) && (lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'checkbox'))OptionActions[idx] = true;
  });
  if (typeof OptionActions === 'undefined') return 0;
  return Object.keys(OptionActions).length;
}

export {
  initializeCounters,
  raiseOption,
  raiseVariable,
  getEditedVariables,
  getEditedOptions,
};



// WEBPACK FOOTER //
// ./src/logic/action_counter.js